/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Fact_StatusInputs */

const en_project_fact_status = /** @type {(inputs: Project_Fact_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const lv_project_fact_status = /** @type {(inputs: Project_Fact_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statuss`)
};

/**
* | output |
* | --- |
* | "Status" |
*
* @param {Project_Fact_StatusInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const project_fact_status = /** @type {((inputs?: Project_Fact_StatusInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Fact_StatusInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_project_fact_status(inputs)
	return en_project_fact_status(inputs)
});